import angular from 'angular';
import MobileAppService from "./mobile-app-service";

let MobileApp = angular
    .module('MobileApp', [])
    .service('MobileAppService', MobileAppService);

export default MobileApp;

